import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import CategoryGrid from "./components/CategoryGrid";
import ArticleClusters from "./components/ArticleClusters";
import Testimonial from "./components/Testimonial";
import CtaSection from "./components/CtaSection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || "https://oopbuyspreadsheets.pics";

    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": siteUrl,
      "name": "OOPBuy Spreadsheet",
      "description": "Smart Product Tracking System for E-commerce Resellers. Automate profit calculation, manage suppliers, and track inventory with 99% accuracy.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": siteUrl + "/?s={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    };

    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "OOPBuy Spreadsheet",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg",
      "sameAs": ["https://kaspreadsheet.com/"],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "url": "https://kaspreadsheet.com/"
      }
    };

    const schemas = [websiteSchema, organizationSchema];
    schemas.forEach((schema, i) => {
      let scriptEl = document.getElementById("schema-home-" + i);
      if (!scriptEl) {
        scriptEl = document.createElement("script");
        scriptEl.id = "schema-home-" + i;
        scriptEl.type = "application/ld+json";
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    });

    return () => {
      for (let i = 0; i < schemas.length; i++) {
        const el = document.getElementById("schema-home-" + i);
        if (el) el.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <About />
        <CategoryGrid />
        <ArticleClusters />
        <Testimonial />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}